import { usePrevious } from '@/hooks';
import { UNKNOWN_CARRIER_ID } from '@/modules/pmt/constants';
import { useCarriersContext } from '@/modules/pmt/context';
import { type IShipmentData, ShipmentSearchStatus } from '@/modules/pmt/interfaces';
import { getShipmentSearchStatus } from '@/modules/pmt/utils';
import { gtmUserSuggestFound } from '@/utils';
import { useStatsigClient } from '@statsig/react-bindings';
import { useEffect } from 'react';

const useTriggerGTMUserSuggestFound = (shipment: IShipmentData) => {
  const { carriersData } = useCarriersContext();
  const { logEvent } = useStatsigClient();
  const carrierId = shipment?.parcel?.carrier?.carrierId;
  const parcelState = getShipmentSearchStatus(shipment);
  const isScrapingWithCarrier = parcelState === ShipmentSearchStatus.ScrapingWithCarrier;
  const prevIsScrapingWithCarrier = usePrevious(isScrapingWithCarrier);

  useEffect(() => {
    if (
      isScrapingWithCarrier !== prevIsScrapingWithCarrier &&
      prevIsScrapingWithCarrier &&
      carriersData &&
      carrierId &&
      carrierId !== UNKNOWN_CARRIER_ID &&
      parcelState === ShipmentSearchStatus.Fetched
    ) {
      const carrierFound = carriersData.find(({ id }) => id === carrierId);
      if (carrierFound) {
        gtmUserSuggestFound(carrierFound.name);
        logEvent('user_suggest_found', 1, {
          carrier_id: carrierId,
          source: 'user_suggest',
        });
      }
    }
  }, [prevIsScrapingWithCarrier, isScrapingWithCarrier, carriersData, carrierId, parcelState, logEvent]);
};

export { useTriggerGTMUserSuggestFound };
